/* Zurielements — main.js */

document.addEventListener('DOMContentLoaded', function () {

  // ─── Footer accordions ───
  document.querySelectorAll('.footer__accordion-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var content = this.nextElementSibling;
      var isOpen = content.classList.contains('open');
      this.classList.toggle('open', !isOpen);
      content.classList.toggle('open', !isOpen);
    });
  });

  // ─── Catalog filter tabs ───
  document.querySelectorAll('.catalog-filter a').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelectorAll('.catalog-filter a').forEach(function (a) {
        a.classList.remove('active');
      });
      this.classList.add('active');
      var tag = this.getAttribute('data-tag');
      document.querySelectorAll('.product-card').forEach(function (card) {
        if (!tag || tag === 'all') {
          card.style.display = '';
        } else {
          card.style.display = card.getAttribute('data-tags') &&
            card.getAttribute('data-tags').includes(tag) ? '' : 'none';
        }
      });
    });
  });

  // ─── Sticky nav scroll effect ───
  var solidNav = document.querySelector('.nav-solid');
  if (solidNav) {
    window.addEventListener('scroll', function () {
      solidNav.style.boxShadow = window.scrollY > 10
        ? '0 1px 20px rgba(24,18,14,0.06)'
        : 'none';
    });
  }

  // ─── Add to cart (Shopify AJAX) ───
  var addToCartForm = document.querySelector('form[action="/cart/add"]');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = this.querySelector('.product-page__btn');
      var originalText = btn.textContent;
      btn.textContent = 'Ajouté ✓';
      btn.style.background = '#5C3D26';
      var formData = new FormData(this);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      }).then(function () {
        setTimeout(function () {
          btn.textContent = originalText;
          btn.style.background = '';
        }, 2000);
      });
    });
  }

});
